import { Autocomplete, BlockStack, Card, InlineGrid, InlineStack, Modal, Select, Tabs, Tag, Text } from "@shopify/polaris";
import { useState } from "react";

export default function SearchTips({ open, close, searchParams, handleSetSearchParams, countries }) {
  const [step, setStep] = useState(0)

  let content;
  if (step === 0) {
    content = (
      <BlockStack gap="200">
        <p>Select a platform to find influencers on</p>
        <Tabs fitted tabs={[{ id: 'instagram', content: 'Instagram' }, { id: 'tiktok', content: 'TikTok' }, { id: 'youtube', content: 'YouTube' }]} selected={0} onSelect={() => { }} />
      </BlockStack>
    )
  } else if (step === 1) {
    content = (
      <BlockStack gap="200">
        <p>Let's apply some influencer filters</p>
        <InlineGrid columns={{ xs: "1", md: "2" }} gap="300">
          <BlockStack gap="100">
            <Text>Followers</Text>
            <InlineGrid columns="2" gap="300" align="start">
              <Select labelInline label="From" options={[
                { label: 'Any', value: 'Any' },
                { label: '1,000', value: '1000' },
                { label: '5,000', value: '5000' },
                { label: '10,000', value: '10000' },
                { label: '50,000', value: '50000' },
                { label: '100,000', value: '100000' },
                { label: '500,000', value: '500000' },
                { label: '1,000,000', value: '1000000' },
              ]}
                value={searchParams.minFollowers}
                onChange={(value) => handleSetSearchParams('minFollowers', value)} />
              <Select labelInline label="To" options={[
                { label: 'Any', value: 'Any' },
                { label: '5,000', value: '5000' },
                { label: '10,000', value: '10000' },
                { label: '50,000', value: '50000' },
                { label: '100,000', value: '100000' },
                { label: '500,000', value: '500000' },
                { label: '1,000,000', value: '1000000' },
                { label: '5,000,000', value: '5000000' },
              ]}
                value={searchParams.maxFollowers}
                onChange={(value) => handleSetSearchParams('maxFollowers', value)} />
            </InlineGrid>
          </BlockStack>
          <BlockStack gap="100">
            <Text>Age</Text>
            <InlineGrid columns="2" gap="300" align="start">
              <Select labelInline label="From" options={[
                { label: 'Any', value: 'Any' },
                { label: '18', value: '18' },
                { label: '25', value: '25' },
                { label: '35', value: '35' },
                { label: '45', value: '45' },
              ]} value={searchParams.minAge} onChange={(value) => handleSetSearchParams('minAge', value)} />
              <Select label="To" labelInline options={[
                { label: 'Any', value: 'Any' },
                { label: '18', value: '18' },
                { label: '25', value: '25' },
                { label: '35', value: '35' },
                { label: '45', value: '45' },
              ]} value={searchParams.maxAge} onChange={(value) => handleSetSearchParams('maxAge', value)} />
            </InlineGrid>
          </BlockStack>
          <Autocomplete
            allowMultiple
            onSelect={(value) => {
              handleSetSearchParams('locations', [...(searchParams.locations || []), value.pop()])
            }}
            label="Country"
            options={
              countries.map(c => ({ label: c, value: c })).filter(i => !(searchParams.locations?.includes(i.value) === true))
            }
            selected={searchParams.locations || []}
            textField={
              <Autocomplete.TextField
                placeholder={searchParams?.locations?.length > 0 ? "Add Location" : "Any"}
                label="Country"
                value={''}
                autoComplete="off"
                verticalContent={
                  searchParams?.locations?.length > 0 ? (
                    <InlineStack gap="300" align="start">
                      {
                        searchParams.locations?.map(interest => {
                          return (
                            <Tag key={interest} onRemove={
                              () => handleSetSearchParams('locations', searchParams.locations.filter(i => i !== interest))
                            }>{interest}
                            </Tag>
                          )
                        })
                      }
                    </InlineStack>
                  ) : null
                }
              />
            }
          />
          <Select label="Gender" options={[
            'Any', 'Male', 'Female'
          ]} value={searchParams.gender}
            onChange={(value) => handleSetSearchParams('gender', value)} />
        </InlineGrid>
        <p>Who do you want to promote your brand?</p>
      </BlockStack>
    )
  } else if (step === 2) {
    content = (
      <BlockStack gap="200">
        <p>There are 3 types of keyword searches</p>
        <InlineGrid columns="3" gap="300">
          <Card>
            <Text variant="headingMd">Keyword</Text>
            <p>Search all captions for brand-related phrases</p>
          </Card>
          <Card>
            <Text variant="headingMd">Bio</Text>
            <p>Search Bio text for more specificity</p>
          </Card>
          <Card>
            <Text variant="headingMd">Mentions</Text>
            <p>Search your brand or competitor names</p>
          </Card>
        </InlineGrid>
      </BlockStack>
    )
  } else if (step === 5) {
    content = (
      <BlockStack gap="200">
        <p>If there are too many results, add more specific filters</p>
        <img key="ff" src="https://assets.codepen.io/6060109/ss-addl-filters.png" />
        <p>For example, Increase engagement rate, reduce fake follower %</p>
      </BlockStack>
    )
  } else if (step === 3) {
    content = (
      <BlockStack gap="200">
        <p>In search results, click "Get Profile" to download stats</p>
        <img key="gp" src="https://assets.codepen.io/6060109/ss-get-profile.png" />
        <p>This will consume 1 credit. Get more at any time.</p>
        <p>Profiles will appear in your Creators tab</p>
      </BlockStack>
    )
  } else {
    content = (
      <BlockStack gap="200">
        <p>Scroll down and press "Load More" for additional results</p>
        <img key="lm" src="https://assets.codepen.io/6060109/ss-load-more.png" />
      </BlockStack>
    )
  }

  return (
    <Modal
      title="Search Guide"
      open={open}
      onClose={close}
      primaryAction={{
        content: step < 4 ? 'Next' : 'Done',
        onAction: () => {
          if (step === 4) {
            close()
          } else {
            setStep(step + 1)
          }
        }
      }}
      secondaryActions={step > 0 ? [{
        content: 'Prev',
        onAction: () => {
          setStep(step - 1)
        }
      }] : null}
    >
      <Modal.Section>
        {content}
      </Modal.Section>
    </Modal>
  )
}
